import { useQuery } from "@tanstack/react-query"
import { makeGetDocType } from "../../domain/use-cases/get-doc-type"
import { httpDocTypeRepository } from "../../data/repositories/doc-type-repository"

const getDocType = makeGetDocType(httpDocTypeRepository)

export const useDocType = (id: string) =>
  useQuery({
    queryKey: ["docType", id],
    queryFn: () => getDocType(id),
    enabled: !!id,
  })
